import { ArticleCategorySort, useCategoryTabsQuery } from './queries'
import { CategoryTabs } from './category-tabs'

export const CategoryTabsContainer = () => {
  const { loading, data } = useCategoryTabsQuery({
    page: 1,
    limit: 10,
    sort: ArticleCategorySort.PositionAsc,
  })

  return <CategoryTabs loading={loading} categoryTabs={data?.ArticleCategories?.docs || []} />
}
